<template>
  <div id="couponBatch">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>优惠券</el-breadcrumb-item>
          <el-breadcrumb-item>优惠券设置</el-breadcrumb-item>
          <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            navigationMap[couponBatchActiveName]
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-form :inline="true"
             label-width="100px"
             class="pageSearch">
      <el-row>
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="setQuerySeller($event)"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券分类::">
          <el-select v-model="fGroupID"
                     filterable
                     placeholder="请选择优惠券分类"
                     clearable>
            <el-option v-for="item in selCouponGroupList"
                       :key="item.fGroupID"
                       :label="item.fGroupName"
                       :value="item.fGroupID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户分组::">
          <el-select v-model="selGroupID"
                     filterable
                     clearable
                     @change="changeGroup"
                     placeholder="请选择商户分组">
            <el-option v-for="item in choiceGroups"
                       :key="item.fSelGrpID"
                       :label="item.fSelGrpName"
                       :value="item.fSelGrpID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称::">
          <el-select v-model="selSellID"
                     filterable
                     clearable
                     placeholder="请选择商户">
            <el-option v-for="item in choiceSellers"
                       :key="item.fSelID"
                       :label="'【' + item.fSelName + '】' + item.fMerName"
                       :value="item.fSelID">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="float:right;margin-right:0px;">
          <el-button type="primary"
                     size="small"
                     v-if="is_edit"
                     @click="addCouponBatch">新增优惠券</el-button>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="优惠券信息::">
          <el-input placeholder="请输入优惠券信息"
                    v-model="selfRemark"
                    style="width:200px;"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item label="优惠券状态::">
          <el-select v-model="selfTypeID"
                     filterable
                     placeholder="请选择优惠券状态">
            <el-option v-for="item in statusList"
                       :key="item.fTypeID"
                       :label="item.Title"
                       :value="item.fTypeID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="couponBatchListQuery">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="couponBatchActiveName"
               type="card"
               @tab-click="tabClick">
        <el-tab-pane label="优惠券列表"
                     name="couponBatchList">
          <el-row>
            <el-table :data="couponBatchList"
                      border
                      highlight-current-row
                      style="width: 100%"
                      v-loading="loading"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fOpLastTimeTitle"
                               width="150"
                               label="最后同步时间">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="75"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fMerName"
                               label="商户名称">
              </el-table-column>
              <el-table-column prop="fGroupName"
                               label="优惠券分类">
              </el-table-column>
              <el-table-column prop="fRemark"
                               width="200"
                               label="优惠券说明">
              </el-table-column>
              <el-table-column prop="fBatStartTimeTitle"
                               width="150"
                               label="起始时间">
              </el-table-column>
              <el-table-column prop="fBatEndTimeTitle"
                               width="150"
                               label="结束时间">
              </el-table-column>
              <el-table-column prop="fBatUseTimeTitle"
                               label="使用时效">
              </el-table-column>
              <el-table-column prop="fCouponValueTitle"
                               width="120"
                               label="抵扣说明">
              </el-table-column>
              <el-table-column prop="fBatNums"
                               align="right"
                               width="75"
                               label="批次数量">
              </el-table-column>
              <el-table-column prop="fCreNums"
                               align="right"
                               width="75"
                               label="生成数量">
              </el-table-column>
              <el-table-column prop="fGetNum"
                               align="right"
                               width="75"
                               label="领用数量">
              </el-table-column>
              <el-table-column prop="fUseNum"
                               align="right"
                               width="75"
                               label="已用数量">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="400">
                <template slot-scope="scope">
                  <el-button @click="viewCouponBatch(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editCouponBatch(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteCouponBatch(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             @click="synCouponBatch(scope.$index, scope.row, false)"
                             v-if="is_syn">上传</el-button>
                  <el-popover placement="top">
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini"
                                 type="warning"
                                 @click="createBatch(scope.$index, scope.row)"
                                 v-if="is_batch">生成优惠券</el-button>
                      <el-button size="mini"
                                 type="success"
                                 @click="viewDetail(scope.$index, scope.row)">优惠券明细</el-button>
                      <el-button size="mini"
                                 type="info"
                                 @click="couponPrint(scope.$index, scope.row, true)"
                                 v-if="is_print">打印一张优惠券</el-button>
                      <el-button size="mini"
                                 type="info"
                                 @click="couponPrintList(scope.$index, scope.row, true)"
                                 v-if="is_print">打印本批优惠券</el-button>
                      <el-button size="mini"
                                 type="danger"
                                 v-if="parseInt(scope.row.fCreNums) > 0 && is_invalid"
                                 @click="invalid(scope.$index, scope.row)">作废</el-button>
                    </div>
                    <el-button slot="reference"
                               size="mini">更多操作</el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待同步"
                     name="syncouponBatchList">
          <el-row>
            <el-table :data="syncouponBatchList"
                      border
                      :row-class-name="tableRowClassName"
                      highlight-current-row
                      style="width: 100%"
                      v-loading="loading"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号"
                               :index="indexMethod">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="160"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fMerName"
                               label="商户名称">
              </el-table-column>
              <el-table-column prop="fGroupName"
                               label="优惠券分类">
              </el-table-column>
              <el-table-column prop="fRemark"
                               width="200"
                               label="优惠券说明">
              </el-table-column>
              <el-table-column prop="fBatStartTimeTitle"
                               width="150"
                               label="起始时间">
              </el-table-column>
              <el-table-column prop="fBatEndTimeTitle"
                               width="150"
                               label="结束时间">
              </el-table-column>
              <el-table-column prop="fBatUseTimeTitle"
                               label="使用时效">
              </el-table-column>
              <el-table-column prop="fCouponValueTitle"
                               width="120"
                               label="抵扣说明">
              </el-table-column>
              <el-table-column prop="fBatNums"
                               align="right"
                               width="75"
                               label="批次数量">
              </el-table-column>
              <el-table-column prop="fCreNums"
                               align="right"
                               width="75"
                               label="生成数量">
              </el-table-column>
              <!-- <el-table-column prop="fGetNum"
                               align="right"
                               width="75"
                               label="领用数量">
              </el-table-column>
              <el-table-column prop="fUseNum"
                               align="right"
                               width="75"
                               label="已用数量">
              </el-table-column> -->
              <el-table-column prop="fSyncRemark"
                               label="同步说明">
              </el-table-column>
              <el-table-column fixed="right"
                               align="center"
                               label="操作"
                               width="400">
                <template slot-scope="scope">
                  <el-button @click="viewCouponBatch(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             @click="editCouponBatch(scope.$index, scope.row)"
                             v-if="is_edit">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             @click="deleteCouponBatch(scope.$index, scope.row)"
                             v-if="is_del">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             @click="synCouponBatch(scope.$index, scope.row, true)"
                             v-if="is_syn&& parseInt(scope.row.fCreNums)>0">下发</el-button>
                  <el-popover placement="top">
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini"
                                 type="warning"
                                 @click="createBatch(scope.$index, scope.row)"
                                 v-if="is_batch&& parseInt(scope.row.fCreNums)==0">生成优惠券</el-button>
                      <el-button size="mini"
                                 type="success"
                                 @click="viewDetail(scope.$index, scope.row)">优惠券明细</el-button>
                      <el-button size="mini"
                                 type="info"
                                 @click="couponPrint(scope.$index, scope.row, true)"
                                 v-if="is_print">打印一张优惠券</el-button>
                      <el-button size="mini"
                                 type="info"
                                 @click="couponPrintList(scope.$index, scope.row, true)"
                                 v-if="is_print">打印本批优惠券</el-button>
                    </div>
                    <el-button slot="reference"
                               size="mini">更多操作</el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total > 0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="couponBatchEditOrDetail">
      <el-dialog :title="detailTitle"
                 :visible.sync="couponBatchEditOrDetailVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="50%">
        <el-form :model="curRowInfo"
                 :rules="rules"
                 ref="form"
                 label-width="140px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="客户::"
                            prop="fCustID">
                <el-select v-model="curRowInfo.fCustID"
                           filterable
                           placeholder="请选择客户"
                           :disabled="!curRowInfo.isEdit"
                           @change="setPark($event, false)"
                           style="width: 100%">
                  <el-option v-for="item in choiceCusts"
                             :key="item.fCustID"
                             :label="item.unionName"
                             :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"
                    v-if="(curRowInfo.fBatchID||'').length>0">
              <el-form-item label="批次ID::">
                <el-input v-model="curRowInfo.fBatchID"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="申请商户::"
                            prop="fAppSelID">
                <el-select v-model="curRowInfo.fAppSelID"
                           filterable
                           placeholder="请选申请商户"
                           :disabled="!curRowInfo.isEdit"
                           style="width: 100%">
                  <el-option v-for="item in sellerList"
                             :key="item.fSelID"
                             :label="'【' + item.fSelName + '】' + item.fMerName"
                             :value="item.fSelID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="优惠券分类::"
                            prop="fGroupID">
                <el-select v-model="curRowInfo.fGroupID"
                           filterable
                           placeholder="优惠券分类"
                           :disabled="!curRowInfo.isEdit"
                           style="width: 100%">
                  <el-option v-for="item in couponGroupList"
                             :key="item.fGroupID"
                             :label="item.fGroupName"
                             :value="item.fGroupID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="适用停车场::"
                            prop="fParkID">
                <el-select v-model="curRowInfo.fParkID"
                           filterable
                           placeholder="请选择场库"
                           :disabled="!curRowInfo.isEdit"
                           style="width: 100%">
                  <el-option v-for="item in parks"
                             :key="item.fParkID"
                             :label="item.fParkName"
                             :value="item.fParkID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <span style="color:red;margin-left:5px;line-height:32px;">有选择适用停车场时，要求该场库与其他场库不互通</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="优惠券名称::"
                            prop="fRemark">
                <el-input v-model="curRowInfo.fRemark"
                          placeholder="请输入优惠券名称"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="起始时间::"
                            prop="fBatStartTimeTitle">
                <el-date-picker v-model="curRowInfo.fBatStartTimeTitle"
                                :disabled="!curRowInfo.isEdit"
                                style="width:200px"
                                type="datetime"
                                :clearable="false"
                                format="yyyy-MM-dd HH:mm"
                                placeholder="选择起始时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间::"
                            prop="fBatEndTimeTitle">
                <el-date-picker v-model="curRowInfo.fBatEndTimeTitle"
                                :disabled="!curRowInfo.isEdit"
                                style="width:200px"
                                type="datetime"
                                :clearable="false"
                                format="yyyy-MM-dd HH:mm"
                                placeholder="选择结束时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="使用时效(分钟)::"
                            prop="fBatUseTime"
                            class="time-form-item">
                <el-input v-model="curRowInfo.fBatUseTime"
                          placeholder="请输入使用时效（分钟）"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit"></el-input>
                <!-- <span style="color:red;">优惠券领用后必须在指定使用时效内完成，值为0时不限制</span> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <span style="color:red;margin-left:5px;line-height:32px;">优惠券领用后必须在指定使用时效内完成，值为0时不限制</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="优惠券抵扣方式::">
                <el-select v-model="curRowInfo.fCouponType"
                           filterable
                           placeholder="请选择优惠券抵扣方式"
                           :disabled="!curRowInfo.isEdit"
                           @change="setCouponValue($event)"
                           style="width: 100%">
                  <el-option v-for="item in choiceCouponTypeList"
                             :key="item.value"
                             :label="item.text"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="fCouponValueTitle"
                            prop="fCouponValue">
                <el-input v-model="curRowInfo.fCouponValue"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit || couponValueEnable"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="允许抵扣的时间段::">
                <el-select v-model="curRowInfo.fPeriodStartTime"
                           placeholder=""
                           :disabled="!curRowInfo.isEdit||disablePeriodTime"
                           style="width:100px;">
                  <el-option v-for="(e,i) in timeRange"
                             :key="i"
                             :label="e"
                             :value="e">
                  </el-option>
                </el-select>
                <span>至</span>
                <el-select v-model="curRowInfo.fPeriodEndTime"
                           placeholder=""
                           :disabled="!curRowInfo.isEdit||disablePeriodTime"
                           style="width:100px;">
                  <el-option v-for="(e,i) in timeRange"
                             :key="i"
                             :label="e"
                             :value="e">
                  </el-option>
                </el-select>
                <span style="color:red;margin-left:5px;line-height:32px;">仅限时间优惠券使用</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="需申请数量::"
                            prop="fBatNums">
                <el-input v-model="curRowInfo.fBatNums"
                          placeholder="请输入需申请数量"
                          autocomplete="off"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="已生成数量::"
                            prop="fCreNums">
                <el-input v-model="curRowInfo.fCreNums"
                          placeholder="请输入已生成数量"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="已领用数量::"
                            prop="fGetNums">
                <el-input v-model="curRowInfo.fGetNum"
                          placeholder="请输入已领用数量"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="已使用数量::"
                            prop="fUseNums">
                <el-input v-model="curRowInfo.fUseNum"
                          placeholder="请输入已使用数量"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="120px"
                            label=" ">
                <el-checkbox v-model="curRowInfo.IsHideValue"
                             :disabled="!curRowInfo.isEdit">打印时隐藏优惠信息</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="120px"
                            label=" ">
                <el-checkbox v-model="curRowInfo.fIsOverly"
                             :disabled="!curRowInfo.isEdit">同车牌允许领取多张优惠券</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('form')"
                     :loading="save_loading"
                     v-if="isShowSaveBtn">{{ save_msg }}</el-button>
          <el-button @click="couponBatchEditOrDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog title="生成优惠券代码"
                 :visible.sync="createCouponVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="40%">
        <el-form :model="createCouponObj"
                 ref="createForm"
                 label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="优惠券说明::"
                            prop="fRemark">
                <el-input v-model="createCouponObj.fRemark"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="需生成数量::"
                            prop="fBatNums">
                <el-input v-model="createCouponObj.fBatNums"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-table :data="this.createCouponObj.couponCode"
                      border
                      highlight-current-row
                      style="width: 100%;overflow-y: auto"
                      height="350px"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fCouponCode"
                               label="优惠券代码">
              </el-table-column>
            </el-table>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     v-loading.fullscreen.lock="createSave_loading"
                     @click="createSubmitForm('createForm')"
                     v-if="createCouponObj.isVisable">开始生成</el-button>
          <el-button @click="createCouponVisible = false">关闭</el-button>
        </div>
      </el-dialog>
      <el-dialog title="优惠券明细清单"
                 :visible.sync="couponDetailVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="50%">
        <el-form :model="viewCouponDetailObj"
                 :rules="rules"
                 ref="form"
                 label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="客户名称::"
                            prop="fCustName">
                <el-input v-model="viewCouponDetailObj.fCustName"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="申请商户::"
                            prop="fSelName">
                <el-input v-model="viewCouponDetailObj.fSelName"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="场库名称::"
                            prop="fParkName">
                <el-input v-model="viewCouponDetailObj.fParkName"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="优惠券名称::"
                            prop="fRemark">
                <el-input v-model="viewCouponDetailObj.fRemark"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="起始时间::"
                            prop="fBatStartTimeTitle">
                <el-input v-model="viewCouponDetailObj.fBatStartTimeTitle"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间::"
                            prop="fBatEndTimeTitle">
                <el-input v-model="viewCouponDetailObj.fBatEndTimeTitle"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="使用时效(分钟)::"
                            prop="fBatUseTime">
                <el-input v-model="viewCouponDetailObj.fBatUseTime"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="优惠券抵扣方式::">
                <el-input v-model="viewCouponDetailObj.fCouponTypeTitle"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="viewCouponDetailObj.fCouponValueTitle"
                            prop="fCouponValue">
                <el-input v-model="viewCouponDetailObj.fCouponValue"
                          autocomplete="off"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-table :data="this.viewCouponDetailObj.detailList"
                      border
                      highlight-current-row
                      style="width: 100%;overflow-y: auto"
                      height="350px"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fCouponCode"
                               label="优惠券代码">
              </el-table-column>
              <el-table-column prop="fGetTimeTitle"
                               label="领用时间">
              </el-table-column>
              <el-table-column prop="fUseTimeTitle"
                               label="使用时间">
              </el-table-column>
              <el-table-column prop="fPrintStatusTitle"
                               width="100"
                               label="打印状态">
              </el-table-column>
            </el-table>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="couponDetailVisible = false">关闭</el-button>
        </div>
      </el-dialog>
      <el-dialog title="优惠券二维码打印"
                 :visible.sync="couponPrintVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="20%">
        <template>
          <section ref="printCouponInfo">
            <el-row style="margin-bottom: 15px">
              <el-col :span="24">
                <span>{{ printCoupon.fRemark }}</span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 15px">
              <el-col :span="24">
                <span>{{ printCoupon.fBatStartTimeTitle }}</span>—<span>{{ printCoupon.fBatEndTimeTitle }}</span>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 15px"
                    v-if="!printCoupon.IsHideValue">
              <el-col :span="24">
                <span>{{ printCoupon.couponValueDes }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24"
                      align="center">
                <img :src="'data:image/png;base64,' + printCoupon.imgBase64"
                     width="203"
                     height="203" />
              </el-col>
            </el-row>
          </section>
        </template>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="couponPrintVisible = false">关 闭</el-button>
          <el-button @click="couponMyPrint()"
                     icon="el-icon-takeaway-box"
                     type="success"
                     size="medium">打 印</el-button>
        </div>
      </el-dialog>
      <el-dialog title="批量打印优惠券二维码"
                 :visible.sync="couponListPrintVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="50%">
        <div style="height: 350px;overflow-y: auto">
          <template>
            <section ref="printCouponList">
              <el-row v-for="(ro, index) in printCouponList.sum"
                      :key="ro">
                <el-col :span="8"
                        v-for="(o, index2) in 3"
                        :key="o">
                  <template v-if="index * 3 + index2 < printCouponList.sum">
                    <el-card :body-style="{ padding: '10px' }">
                      <img :src="
                          'data:image/png;base64,' +
                            printCouponList.imgList[index * 3 + index2]
                        "
                           width="203"
                           height="160" />
                      <div>
                        <span>优惠券</span>
                        <div class="bottom clearfix">
                          生效日期：{{ printCouponList.fBatStartTimeTitle }}
                        </div>
                        <div class="bottom clearfix">
                          失效日期：{{ printCouponList.fBatEndTimeTitle }}
                        </div>
                        <div class="bottom clearfix"
                             v-if="!printCouponList.IsHideValue">
                          {{ printCouponList.couponValueDes }}
                        </div>
                      </div>
                    </el-card>
                  </template>
                </el-col>
                <template v-if="index % 4 === 0">
                  <div style="page-break-after:always"></div>
                </template>
              </el-row>
            </section>
          </template>
        </div>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="couponListPrintVisible = false">关 闭</el-button>
          <el-button @click="couponListMyPrint()"
                     icon="el-icon-takeaway-box"
                     type="success"
                     size="medium">打 印</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { coupon as api } from '../../api/coupon'
import * as user from '../../api/user'
import { mapActions } from 'vuex'
export default {
  name: 'couponBatch.vue',
  data () {
    var validateName = (rule, value, callback) => {
      if ((value || '').length > 0) {
        var patrn = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/
        if (!patrn.test(value)) {
          callback(new Error('不能包含特殊字符'))
        }
      }
      callback()
    }
    return {
      selGroupID: '',
      choiceGroups: [],
      export_loading: false,
      couponDetailVisible: false,
      save_loading: false,
      createBatch_loading: false,
      couponListPrintVisible: false,
      couponPrintVisible: false,
      createSave_loading: false,
      viewCouponDetail_loading: false,
      isShowSaveBtn: false,
      loading: false,
      save_msg: '保存',
      export_msg: '导出',
      createCouponObj: {
        fRemark: '',
        fBatNums: 0,
        isVisable: true,
        couponCode: ''
      },
      printCouponList: {
        couponValueDes: '',
        fBatStartTimeTitle: '',
        fBatEndTimeTitle: '',
        imgList: [],
        sum: 10
      },
      timeRange: [],
      couponGroupList: [{ fGroupID: '0', fGroupName: '无' }],
      selCouponGroupList: [],
      fGroupID: '',
      printCoupon: {
        couponValueDes: '',
        fCouponCode: '',
        imgBase64: '',
        printCoupon: false
      },
      viewCouponDetailObj: {
        fCustID: '',
        fCustName: '',
        fAppSelID: '',
        fSelName: '',
        fParkID: '',
        fParkName: '',
        fRemark: '',
        fBatStartTime: '',
        fBatStartTimeTitle: '',
        fBatEndTimeTitle: '',
        fBatEndTime: '',
        fBatUseTime: '',
        fCouponType: '',
        fCouponValue: '',
        fBatNums: '',
        fCreNums: '',
        fGetNums: '',
        fUseNums: '',
        detailList: [],
        fCouponTypeTitle: '',
        fCouponValueTitle: ''
      },
      curRowInfo: {
        op: '',
        isEdit: false,
        fCustID: '',
        fAppSelID: '',
        fParkID: '',
        fRemark: '',
        fBatStartTime: '',
        fBatStartTimeTitle: '',
        fBatEndTimeTitle: '',
        fBatEndTime: '',
        fBatUseTime: '',
        fCouponType: '',
        fCouponValue: '',
        fBatNums: '',
        fCreNums: '',
        fGetNums: '',
        fUseNums: '',
        fPeriodStartTime: '00:00',
        fPeriodEndTime: '24:00',
        fGroupID: '0',
        IsHideValue: false,
        fIsOverly: false
      },
      formLabelWidth: '120px',
      createCouponVisible: false,
      couponBatchEditOrDetailVisible: false,
      detailTitle: '',
      syncouponBatchList: [],
      couponBatchList: [],
      is_edit: false,
      is_del: false,
      is_syn: false,
      is_print: false,
      is_batch: false,
      is_export: false,
      is_invalid: false,
      navigationMap: {
        couponBatchList: '优惠券列表',
        syncouponBatchList: '待同步'
      },
      selfTypeID: '1',
      selCustID: '',
      selfRemark: '',
      choiceCusts: [],
      selSellID: '',
      choiceSellers: [],
      sellerList: [],
      choiceCouponTypeList: [],
      parks: [],
      statusList: [
        { fTypeID: '1', Title: '使用中' },
        { fTypeID: '2', Title: '已失效' }
      ],
      couponBatchActiveName: 'couponBatchList',
      tableHeight: 0,
      rules: {
        fCustID: [{ required: true, message: '请选择客户', trigger: 'change' }],
        fRemark: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' },
          { min: 1, max: 99, message: '长度在 1 到 99 个字符', trigger: 'blur' }
        ]
      },
      pageSize: 20,
      pageNo: 1,
      total: 0,
      couponValueEnable: false
    }
  },
  computed: {
    fCouponValueTitle: function () {
      let value = this.curRowInfo.fCouponType
      let text = ''
      for (var i = 0; i < this.choiceCouponTypeList.length; i++) {
        if (this.choiceCouponTypeList[i].value === value) {
          text = this.choiceCouponTypeList[i].text
        }
      }
      return text + '::'
    },
    disablePeriodTime: function () {
      let val = this.curRowInfo.fCouponType
      if (val === '2') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapActions(['getCustByGroup', 'getParkList']),
    invalid (index, row) {
      this.$confirm(
        '是否将【' +
        row.fCustName +
        '】的优惠券批次【' +
        row.fRemark +
        '】作废, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          api
            .couponBatchToInvalid({
              fCustID: row.fCustID,
              fBatchID: row.fBatchID
            })
            .then(res => {
              if (res && res.data) {
                var data = res.data
                if (data.IsOk) {
                  this.$message.success('提示：' + data.Msg)
                } else {
                  this.$message.error('提示：' + data.Msg)
                }
              }
            })
        })
        .catch(() => { })
    },
    changeGroup (val) {
      this.choiceSellers = []
      this.selSellID = ''
      if (val || this.selCustID) {
        this.setSellDDL(this.selCustID, val).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.choiceSellers = data.Data || []
              }
            }
          }
        })
      }
    },
    couponMyPrint () {
      var _this = this
      this.$myPrint(this.$refs.printCouponInfo, {
        onEnd: function () {
          _this.couponPrintVisible = false
          api.updatePrintCoupon(_this.printCoupon).then(res => {
            let { status, data } = res
            if (status !== 200) {
              _this.$message.error('提示：打印优惠券出错')
            } else {
              if (!data.IsOk) {
                _this.$message.error(data.Msg)
              } else {
                _this.initData()
              }
            }
          })
        }
      })
    },
    couponListMyPrint () {
      var _this = this
      this.$myPrint(this.$refs.printCouponList, {
        onEnd: function () {
          _this.couponListPrintVisible = false
          _this.printCouponList.imgList = []
          api.updatePrintCouponList(_this.printCouponList).then(res => {
            let { status, data } = res
            if (status !== 200) {
              _this.$message.error('提示：打印优惠券出错')
            } else {
              if (!data.IsOk) {
                _this.$message.error(data.Msg)
              } else {
                _this.initData()
              }
            }
          })
        }
      })
    },
    setCouponValue (val) {
      this.curRowInfo.fCouponValue = ''
      this.couponValueEnable = false
      if (val === '0') {
        this.curRowInfo.fCouponValue = 0
        this.couponValueEnable = true
      }
    },
    setPark (val, isEdit) {
      this.parks = []
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              // Object.assign(this.parks, data.Data || [])
              this.parks = data.Data || []
            }
          }
          let all = {}
          all['fParkID'] = '0'
          all['fParkName'] = '所有停车场'
          this.parks.unshift(all)
          if (!isEdit) {
            this.curRowInfo.fParkID = '0'
          }
        }
      })
      this.couponGroupList = [{ fGroupID: '0', fGroupName: '无' }]
      this.curRowInfo.fGroupID = '0'
      api.getCouponGroupList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.couponGroupList.push(...(data.Data || []))
            }
          }
        }
      })
      this.sellerList = []
      this.curRowInfo.fAppSelID = ''
      this.setSellDDL(val).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.sellerList = data.Data || []
              if (this.sellerList && this.sellerList.length > 0 && !isEdit) {
                this.curRowInfo.fAppSelID = this.sellerList[0].fSelID
              }
            }
          }
        }
      })
    },
    setQuerySeller (val) {
      this.choiceSellers = []
      this.selSellID = ''
      this.selCouponGroupList = []
      this.fGroupID = ''
      this.choiceGroups = []
      this.selGroupID = ''
      if (!val) { return }
      this.setSellDDL(val, this.selGroupID).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.choiceSellers = data.Data || []
            }
          }
        }
      })
      api.getCouponGroupList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.selCouponGroupList = data.Data || []
            }
          }
        }
      })

      api.getSellerGroupList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.choiceGroups = data.Data || []
            }
          }
        }
      })
      // api.getSellerListByCustIDAsync({ fCustID: val }).then(res => {
      //   if (res && res.data) {
      //     let { status, data } = res
      //     if (status === 200) {
      //       if (data.IsOk) {
      //         this.choiceSellers = data.Data || []
      //       }
      //     }
      //     let all = {}
      //     all['fSelID'] = '0'
      //     all['fSelName'] = '所有商户'
      //     this.choiceSellers.unshift(all)
      //     this.selSellID = '0'
      //   }
      // })
    },
    setSellDDL (fCustID, fSelGrpID) {
      return api.getSellerListByCustIDAsync({ fCustID: fCustID, fSelGrpID: fSelGrpID })
    },
    setDefault () {
      this.sellerList = []
      let tmp = this.curRowInfo.fCouponType
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      this.curRowInfo.fPeriodStartTime = '00:00'
      this.curRowInfo.fPeriodEndTime = '24:00'
      this.curRowInfo.fGroupID = '0'
      var today = new Date()
      this.curRowInfo.fBatStartTimeTitle = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0
      )
      this.curRowInfo.fBatEndTimeTitle = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        23,
        59,
        59
      )
      this.curRowInfo['fParkID'] = '0'
      this.curRowInfo.fCouponType = tmp
      this.curRowInfo.fCreNums = 0
      this.curRowInfo.fGetNums = 0
      this.curRowInfo.fUseNums = 0
      this.curRowInfo.IsHideValue = false
      this.curRowInfo.fIsOverly = false
    },
    synCouponBatch (index, row, isSyn) {
      if (row && row !== null && typeof row !== 'undefined') {
        var msg = ''
        if (isSyn) {
          if (row.fBatNums !== row.fCreNums) {
            var message = ''
            message = '优惠券正在生成，请稍后下发'
            this.$message.error(message)
            return false
          }
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm(
          '将客户[' +
          row.fCustName +
          ']的优惠券[' +
          row.fRemark +
          ']' +
          msg +
          ', 是否继续?',
          '提示',
          {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }
        )
          .then(() => {
            api
              .synCouponBatchById({
                fBigRowID: row.fBigRowID,
                fIsSyn: isSyn
              })
              .then(res => {
                let { status, data } = res
                if (status === 200) {
                  if (data.IsOk) {
                    this.$message({
                      type: 'success',
                      message: '操作完成'
                    })
                    this.initData()
                  } else {
                    this.$message.error('提示：' + data.Msg)
                  }
                }
              })
          })
          .catch(() => { })
      }
    },
    submitForm (formName) {
      let timeFormat = 'yyyy-MM-dd hh:mm:ss'
      var dateStart = new Date(this.curRowInfo.fBatStartTimeTitle)
      var dateEnd = new Date(this.curRowInfo.fBatEndTimeTitle)
      if (dateStart >= dateEnd) {
        this.$message.error('提示：优惠券【起始时间】要小于【结束时间】')
        return
      }
      dateStart.setFullYear(dateStart.getFullYear() + 1)

      if (dateEnd > dateStart) {
        this.$message.error('提示：优惠券有效期要小于一年')
        return
      }
      if (this.curRowInfo.fBatStartTimeTitle instanceof Date) {
        this.curRowInfo.fBatStartTimeTitle = this.$dateFormat(
          this.curRowInfo.fBatStartTimeTitle,
          timeFormat
        )
      }
      if (this.curRowInfo.fBatEndTimeTitle instanceof Date) {
        this.curRowInfo.fBatEndTimeTitle = this.$dateFormat(
          this.curRowInfo.fBatEndTimeTitle,
          timeFormat
        )
      }

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save_loading = true
          this.save_msg = '保存中…'
          api.saveCouponBatch(this.curRowInfo).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            let { status, data } = res
            if (status !== 200) {
              this.$message.error('提示：优惠券操作出错')
            } else {
              if (!data.IsOk) {
                this.$message.error(data.Msg)
              } else {
                this.initData()
                this.$message.success(data.Msg)
                this.couponBatchEditOrDetailVisible = false
              }
            }
          })
        } else {
          console.log('couponBatch error submit!!')
          return false
        }
      })
    },
    addCouponBatch () {
      this.setDefault()
      this.isShowSaveBtn = true
      this.couponBatchEditOrDetailVisible = true
      this.curRowInfo.op = 'add'
      this.curRowInfo.isEdit = true
      this.curRowInfo.fBatUseTime = '1440'
      this.detailTitle = '新增优惠券'
      this.setCouponValue(this.curRowInfo.fCouponType)
      setTimeout(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      }, 50)
    },
    createSubmitForm (formName) {
      if (parseInt(this.createCouponObj.fBatNums) > 3000) {
        this.$message.success('本批优惠券数量不能超过 3000。')
        return
      }
      this.createSave_loading = true
      var isSyn = this.couponBatchActiveName === 'syncouponBatchList'
      this.createCouponObj.isSyn = isSyn
      api
        .createBatchData(this.createCouponObj)
        .then(res => {
          this.createSave_loading = false
          let { status, data } = res
          if (status !== 200) {
            this.$message.error('提示：生成优惠券操作出错')
          } else {
            if (!data.IsOk) {
              this.$message.error(data.Msg)
            } else {
              this.$message.success(data.Msg)
              this.createCouponObj.isVisable = false
              this.createCouponObj.couponCode = data.Data || []
              this.initData()
            }
          }
        })
        .catch(() => {
          this.createSave_loading = false
        })
      // this.createSave_loading = false
    },
    couponPrintList (index, row) {
      for (let key in this.printCouponList) {
        this.printCouponList[key] = ''
      }
      this.printCouponList.sum = 0
      this.printCouponList.imgList = []
      if (row && row !== null && typeof row !== 'undefined') {
        Object.assign(this.printCouponList, row)
        this.printCouponList.fIsSyn =
          this.couponBatchActiveName === 'syncouponBatchList'
        api.printCouponList(this.printCouponList).then(res => {
          let { status, data } = res
          if (status !== 200) {
            this.$message.error('提示：批量打印优惠券操作出错')
          } else {
            if (!data.IsOk) {
              this.$message.error(data.Msg)
            } else {
              if (data.Data) {
                this.couponListPrintVisible = true
                this.printCouponList.couponValueDes = data.Data.couponValueDes
                this.printCouponList.sum = data.Data.sum
                this.printCouponList.imgList = data.Data.imgList || []
              }
            }
          }
        })
      }
    },
    couponPrint (index, row) {
      for (let key in this.printCoupon) {
        this.printCoupon[key] = ''
      }
      if (row && row !== null && typeof row !== 'undefined') {
        Object.assign(this.printCoupon, row)
        this.printCoupon.fIsSyn =
          this.couponBatchActiveName === 'syncouponBatchList'
        api.printCouponByID(this.printCoupon).then(res => {
          let { status, data } = res
          if (status !== 200) {
            this.$message.error('提示：生成优惠券操作出错')
          } else {
            if (!data.IsOk) {
              this.$message.error(data.Msg)
            } else {
              if (data.Data) {
                this.couponPrintVisible = true
                this.printCoupon.couponValueDes = data.Data.couponValueDes
                this.printCoupon.fCouponCode = data.Data.fCouponCode
                this.printCoupon.imgBase64 = data.Data.imgBase64 || ''
              }
            }
          }
        })
      }
    },
    viewDetail (index, row) {
      for (let key in this.viewCouponDetailObj) {
        this.viewCouponDetailObj[key] = ''
      }
      if (row && row !== null && typeof row !== 'undefined') {
        row.detailList = []
        Object.assign(this.viewCouponDetailObj, row)
        let value = this.viewCouponDetailObj.fCouponType
        let text = ''
        for (var i = 0; i < this.choiceCouponTypeList.length; i++) {
          if (this.choiceCouponTypeList[i].value === value) {
            text = this.choiceCouponTypeList[i].text
          }
        }
        this.viewCouponDetailObj.fCouponTypeTitle = text
        this.viewCouponDetailObj.fCouponValueTitle = text + '::'
        this.viewCouponDetail_loading = true
        var isSyn = this.couponBatchActiveName === 'syncouponBatchList'
        this.viewCouponDetailObj.fIsSyn = isSyn
        this.couponDetailVisible = true
        this.viewCouponDetailObj.fUseStatus = this.selfTypeID
        api.getCouponBatchDetail(this.viewCouponDetailObj).then(res => {
          this.viewCouponDetail_loading = false
          let { status, data } = res
          if (status !== 200) {
            this.$message.error('提示：生成优惠券操作出错')
          } else {
            if (!data.IsOk) {
              this.$message.error(data.Msg)
            } else {
              if (data.Data) {
                this.viewCouponDetailObj.fParkName = data.Data.fParkName
                this.viewCouponDetailObj.detailList = data.Data.detailList || []
              }
            }
          }
        })
        this.viewCouponDetail_loading = false
      }
    },
    createBatch (index, row) {
      this.createCouponObj.couponCode = []
      this.createCouponObj.fBatNums = ''
      this.createCouponObj.fRemark = ''
      if (row && row !== null && typeof row !== 'undefined') {
        if (parseInt(row.fCreNums) > 0) {
          this.$message.success('该批次优惠券已经生成。')
        } else {
          Object.assign(this.createCouponObj, row)
          this.createCouponObj.fBatNums = row.fBatNums
          this.createCouponObj.fRemark = row.fRemark
          this.createCouponObj.isVisable = true
          this.createCouponObj.couponCode = []
          this.createCouponVisible = true
        }
      }
    },
    editCouponBatch (index, row) {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate()
      }
      if (row && row !== null && typeof row !== 'undefined') {
        this.setPark(row.fCustID, true)
        let curRow = {}
        Object.assign(curRow, row)
        this.curRowInfo = curRow
        this.detailTitle = '【' + row.fRemark + '】编辑优惠券'
        this.curRowInfo.isEdit = true
        this.curRowInfo.op = 'edit'
        this.curRowInfo.fIsSyn = this.couponBatchActiveName === 'syncouponBatchList'
        this.couponBatchEditOrDetailVisible = true
        this.isShowSaveBtn = true
        if (parseInt(row.fCreNums) > 0) {
          this.curRowInfo.isEdit = false
        }
      }
    },
    viewCouponBatch (row) {
      this.curRowInfo.isEdit = false
      this.isShowSaveBtn = false
      if (row && row !== null && typeof row !== 'undefined') {
        this.setPark(row.fCustID, true)
        Object.assign(this.curRowInfo, row)
        this.detailTitle = '【' + row.fRemark + '】查看优惠券'
        this.couponBatchEditOrDetailVisible = true
      }
    },
    deleteCouponBatch (index, row) {
      if (this.couponBatchActiveName !== 'syncouponBatchList') {
        if (parseInt(row.fCreNums) > 0) {
          this.$message({
            type: 'success',
            message: '该优惠券已有使用记录，无法删除。'
          })
          return
        }
      }
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let curRow = {}
          Object.assign(curRow, row)
          curRow['fIsSyn'] = this.couponBatchActiveName === 'syncouponBatchList'
          api.deleteCouponBatch(curRow).then(res => {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          })
        })
        .catch(_ => {
          console.log(_)
        })
    },
    couponBatchListQuery () {
      this.initData()
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    initData () {
      var isSyn = this.couponBatchActiveName === 'syncouponBatchList'
      this.total = 0
      if (isSyn) {
        this.syncouponBatchList = []
      } else {
        this.couponBatchList = []
      }
      this.loading = true
      api.couponBatchList({
        fGroupID: this.fGroupID,
        fCustID: this.selCustID,
        fTypeID: this.selfTypeID,
        fUseStatus: this.selfTypeID,
        fSelGrpID: this.selGroupID,
        fAppSelID: this.selSellID,
        fRemark: this.selfRemark,
        isSync: isSyn,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      })
        .then(res => {
          this.loading = false
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                if (isSyn) {
                  this.syncouponBatchList = data.Data.rows
                } else {
                  this.couponBatchList = data.Data.rows
                }
                this.total = data.Data.total
              } else {
                this.$message.error('提示:' + data.Msg)
              }
            } else {
              this.$message.error('提示:' + data.Msg)
            }
          }
        })
    },
    exportData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      var isSyn = this.couponBatchActiveName === 'syncouponBatchList'
      api.couponBatchList({
        isExport: 1,
        fGroupID: this.fGroupID,
        fCustID: this.selCustID,
        fTypeID: this.selfTypeID,
        fUseStatus: this.selfTypeID,
        fAppSelID: this.selSellID,
        fRemark: this.selfRemark,
        isSync: isSyn,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      }).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_优惠券批次.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 279
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 200000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
            this.is_print = data.Data.data.is_print
            this.is_batch = data.Data.data.is_batch
            this.is_invalid = data.Data.data.is_invalid
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
    this.initData()
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }

    this.getCustByGroup().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.choiceCusts = data.Data
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.setQuerySeller(this.selCustID)
            }
          }
        }
      }
    })
    api.getTypeList({}).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            Object.assign(this.choiceCouponTypeList, data.Data.CouponTypeList)
            this.curRowInfo.fCouponType = data.Data.CouponTypeList_defaultValue
          }
        }
      }
    })
    for (var i = 0; i <= 24; i++) {
      this.timeRange.push((i < 10 ? '0' + i : i) + ':00')
      if (i < 24) {
        this.timeRange.push((i < 10 ? '0' + i : i) + ':30')
      }
    }
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
#couponBatch .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
#couponBatch
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
#couponBatch .is-disabled .el-input__inner,
#couponBatch .is-disabled .el-textarea__inner {
  color: #606266;
}
#couponBatch .warning-row {
  color: chocolate;
}
#couponBatch .time-form-item .el-form-item__content {
  line-height: normal;
}
.couponBatchEditOrDetail .el-dialog__title {
  color: white;
}
.couponBatchEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.couponBatchEditOrDetail .el-dialog__body {
  padding-bottom: 5px;
}
.couponBatchEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
@page {
  margin: 5px;
}
</style>
<style scoped>
.pagination {
  text-align: right;
  padding-top: 5px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
@page {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/coupon/couponBatch.vue